/**
 * analytics.js
 * 
 * A wrapper for supplementary functionality for Google Analytics.
 */
;(function($, window, document) {

  // One Trust "accept all cookies" popup buttons
  $(document).on('click', '#accept-recommended-btn-handler, .ot-pc-refuse-all-handler, .save-preference-btn-handler', function() {
    analytics_gtm_init();
  })

  // One Trust "accept all cookies" banner buttons
  $(document).on('click', '#onetrust-pc-btn-handler, #onetrust-reject-all-handler, #onetrust-accept-btn-handler', function() {
    analytics_gtm_init();
  })



  function analytics_gtm_init() {
    if (!window.dataLayer) { return; }
    window.dataLayer.push({event: 'gtm.init'})
  }



  


  // Add Publish date for articles
  if ($('body').hasClass('single-article')) {

    if (!window.dataLayer) { return; }
    
    const modifiedTime = $('meta[property="article:modified_time"]').attr('content');
    if (modifiedTime) {
      window.dataLayer.push({publishDate: modifiedTime});
    }

  }

})(jQuery, window, document);